<template>
  <el-table
    ref="multipleTable"
    v-loading="loading"
    element-loading-text="Loading"
    :data="tableData"
    border
    fit
    tooltip-effect="dark"
    style="width: 100%"
    :row-style="rowstyle"
    :header-cell-style="{ backgroundColor: '#f5f5f5' }"
    @sort-change="handleSortChange"
    @selection-change="handleSelectionChange"
  >
    <!-- <div v-for="(item) in tableLabel"  :key="item.label">
            <el-table-column v-if="item.type" :type="item.type?item.type:''" :fixed="item.fixed?item.fixed:false"></el-table-column>
            <el-table-column v-else :width="item.width ? item.width : ''" :fixed="item.fixed?item.fixed:false"  :align="item.align" :label="item.label" :prop="item.param" :sortable="item.sortable ? 'custom' : false">
                   <template slot-scope="scope">
                       <slot v-if="item.slot" :scope="scope" :name="item.slot"></slot>
                       <div v-html="item.render(scope.row)" v-else-if="item.render"> -->
    <!-- {{item.render(scope.row)}} -->
    <!-- </div>
                      <span v-else>{{scope.row[item.param]}} {{item.type}}</span>
                  </template>
            </el-table-column>
        </div> -->
    <!--多选列-->
    <el-table-column
      v-if="selectionShow"
      type="selection"
      width="50"
      align="center"
      highlight-current-row
      fixed
    ></el-table-column>
    <el-table-column
      v-for="(item, index) in tableLabel"
      v-show="index == 1"
      :key="item.id"
      :width="item.width ? item.width : ''"
      :fixed="item.fixed ? item.fixed : false"
      :type="item.type ? item.type : ''"
      :align="item.align"
      :label="item.label"
      :prop="item.param"
      :sortable="item.sortable ? 'custom' : false"
    >
      <template v-if="item.header ? item.header : false" slot="header">
        <span>订单是否确认</span>
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">
            选择”否”项表示不需要确认即生成有效订单（集成订单使用无效），默认订单都需要确认。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </template>
      <template v-if="item.unit ? item.unit : false" slot="header">
        <div class="pointer" @click="handleButton('addUnit')">
          <span>计量单位</span>
          <i class="el-icon-circle-plus-outline"></i>
        </div>
      </template>
      <template slot-scope="scope">
        <slot v-if="item.slot" :scope="scope" :name="item.slot">
          <span v-show="scope.row[item.param].isBatch">{{
            scope.row[item.param].attributeValue +
            scope.row[item.param].unitValue
          }}</span>
          <div
            @click="
              handleInput(
                scope.$index,
                scope.row[item.param].attributeId,
                scope.row[item.param].attributeName,
                scope.row.id
              )
            "
          >
            <el-input
              v-show="!scope.row[item.param].isBatch"
              ref="input"
              v-model="scope.row[item.param].val"
              readonly="true"
            ></el-input>
          </div>

          <!-- <el-input v-show="item.isProduct?item.isProduct:false" v-model="scope.row[item.param].val" @focus="handleInput(scope.$index,scope.row[item.param].attributeId,scope.row[item.param].attributeName)"></el-input> -->
        </slot>
        <div v-else-if="item.render" v-html="item.render(scope.row)"></div>
        <span v-else>{{ scope.row[item.param] }} {{ item.type }}</span>
      </template>
    </el-table-column>

    <el-table-column
      v-if="tableOption.label"
      :width="tableOption.width"
      :label="tableOption.label"
      align="center"
      class-name="small-padding fixed-width"
      :fixed="tableOption.fixed ? tableOption.fixed : false"
    >
      <template slot-scope="scope">
        <template v-if="tableOption.flag">
          <el-button
            v-for="(item, index) in tableOption.options"
            v-show="
              (scope.row.orderStatusNum == '17' &&
                item.label == '查看并确认') ||
              ((scope.row.orderStatusNum == '31' ||
                scope.row.orderStatusNum == '32') &&
                item.label == '发货') ||
              item.label == '订单详情'
            "
            :key="index"
            :type="item.type"
            :icon="item.icon"
            size="mini"
            @click="handleButton(item.methods, scope.row, scope.row)"
          >
            {{ item.label }}
          </el-button>
        </template>

        <template v-else>
          <el-button
            v-for="(item, index) in tableOption.options"
            :key="index"
            :type="item.type"
            :icon="item.icon"
            size="mini"
            :disabled="item.disabled"
            @click="handleButton(item.methods, scope.row, scope.row)"
          >
            {{ item.label }}
          </el-button>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    repeatList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableLabel: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableOption: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectionShow: {
      type: Boolean,
      default: false,
    },
    radioShow: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    console.log(11);
  },
  methods: {
    rowstyle({ row }) {
      // console.log(row, rowIndex);
      const stylejson = {};
      if (this.repeatList.indexOf(row.id) != -1) {
        stylejson.background = '#FDEDEE'; // 背景颜色
        // 也可以修改文字颜色
        // stylejson.color='green' ;
        return stylejson;
      }
      return '';
    },
    handleButton(methods, row, index) {
      // 按钮事件
      this.$emit('handleButton', { methods, row, index });
    },
    handleSortChange(val) {
      // 排序
      this.$emit('handleSortChange', val);
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
    handleInput(index, val, standardName, id) {
      this.$emit('handleInput', { index, val, standardName, id });
    },
    selectSingleTableAll(val) {
      console.log(val);
      this.$emit('handleSelectSingleTableAll', val);
    },
    toggleRowSelection() {
      this.tableData.forEach((item) => {
        // debugger
        this.$refs.multipleTable.toggleRowSelection(item, true);
      });
    },
    clearSelection() {
      this.tableData.forEach((item) => {
        this.$refs.multipleTable.clearSelection(item, true);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>
>
